enum TileType {
  DownPayment = 'DownPayment',
  GreatDeal = 'GreatDeal',
  Finance = 'Finance',
  SaveSearch = 'SaveSearch',
  TradeIn = 'TradeIn',
  Vehicle = 'Vehicle'
}

export default TileType;
